import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Icons(props) {
  const {
    className,
    children,
    wrap,
    allowShrink,
    spacing = 'comfortable'
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.icons, wrap && styles.wrap, allowShrink && styles.allowShrink, spacingToStyleMap[spacing], className)
  }, children);
}

var Icons$1 = genericMemo(Icons);

export { Icons$1 as default };
//# sourceMappingURL=index.js.map
